import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'

import CreateAgent from './create'
import ViewAgent from './view'
import ListAgents from './list'

const AgentsIndex = (props) => {
    return (
        <Routes>
            <Route path={nestedRoutePath(routes.agentsIndex, routes.agentsCreate)} element={<CreateAgent />} />
            <Route path={nestedRoutePath(routes.agentsIndex, routes.agentsView)} element={<ViewAgent />} />
            <Route index element={<ListAgents />} />
        </Routes>
    )
}

export default AgentsIndex
